import styled from 'styled-components';
import { Tooltip as KTooltip } from '@progress/kendo-react-tooltip';

const Tooltip = styled(KTooltip)`
  .k-tooltip {
    background: #000;
  }

  .k-callout {
    color: #000;
  }

  .k-tooltip-content {
    font-size: 14px;
  }
`;

export default Tooltip;
